<div fxLayout="row" class="background">
  <div fxFlex="80" fxFlexOffset="10%">

    <section id="header">
      <div fxLayout="row" fxLayoutAlign="start center">
        <h1 class="h1Header">HOLA!</h1>
        <h1 class="second h1Header">DELIVERY</h1>
      </div>
    </section>

    <section id="body">
      <div fxLayout="row" fxLayoutAlign="center" fxLayoutGap="1rem">

        <mat-card class="stat-card">
          <mat-icon class="home">home</mat-icon>
          <p class="stat-header">Total de tiendas</p>
          <p>{{totals.stores}}</p>
        </mat-card>

        <mat-card class="stat-card">
          <mat-icon class="shopping_cart">shopping_cart</mat-icon>
          <p class="stat-header">Total de pedidos</p>
          <p>{{totals.orders}}</p>
        </mat-card>

        <mat-card class="stat-card">
          <mat-icon class="calendar">calendar_today</mat-icon>
          <p class="stat-header">Pedidos completados</p>
          <p>{{totals.completedOrders}}</p>
        </mat-card>

        <mat-card class="stat-card">
          <mat-icon class="cart">shopping_cart</mat-icon>
          <p class="stat-header">Pedidos de este mes</p>
          <p>{{totals.thisMonthOrders}}</p>
        </mat-card>

        <mat-card class="stat-card">
          <mat-icon class="person">person</mat-icon>
          <p class="stat-header">Usuarios de la aplicación</p>
          <p>{{totals.totalUsers}}</p>
        </mat-card>

      </div>

      <app-recent-orders></app-recent-orders>
    </section>
    <br>
  </div>
</div>